import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Header extends Component {

	componentDidMount() {

	}

	//logout = (username) => {
	//this.props.onCallBack({"role":"","islogged":false});
	//}

	render() {

		//let config = this.props.config;
		//let auth = this.props.auth;
		//let path = this.props.path;
		//let onCallBack = this.props.onCallBack;
		const FEEDBACK_FORM = 'https://forms.office.com/r/xArn0pjwQZ';

		/**
		 * Submit feedback form
		 * 	Sends user to an external form for feedback about product experiences		 
		 */
		const submitFeedback = () => {
			window.open(FEEDBACK_FORM, '_blank');
		};

		//console.log('Header auth . . . . : ', auth);

		return (

			<div className="header">
				<div className="leftcol">
					<Link to={process.env.REACT_APP_PUBLIC_URL}>
						<div className="header-content">
							<div className="logo">
								<img className="logo" src={`${process.env.REACT_APP_PUBLIC_URL}/assets/images/ui/logo.png`} alt="logo" />
							</div>
							<div className="page-title">
								{this.props.config.title}
							</div>
						</div>
					</Link>
				</div>
				<div className="rightcol">

					<div className="logout">
						<h1> </h1>
						<button className="hpbtn" onClick={submitFeedback}>Submit Feedback</button>						
					</div>



				</div>

			</div>
		)
	}
}

export default Header;